<template>
  <b-container>
    <date-range-picker v-model="date_range" :maxDate="new Date()" :minDate="site.created.toDate()" :always-show-calendars	="false" :auto-apply="false" class="mb-2"></date-range-picker>

    <b-card-group deck>
      <b-card class="mb-2">
        <h4>Live <i class="live fas fa-circle fa-blink" v-if="live_stats.live_total"></i></h4>
        <b-card-text>
          {{live_stats.live_total}}
        </b-card-text>
      </b-card>

      <b-card title="New users" class="mb-2">
        <b-card-text>
          {{stats.new_users}}
        </b-card-text>
      </b-card>

      <b-card title="Returning users" class="mb-2">
        <b-card-text>
          {{stats.returning_users}}
        </b-card-text>
      </b-card>
    </b-card-group>

    <b-card no-body class="mt-4">
      <b-table :items="stats.referrers" :fields="fields" show-empty></b-table>
    </b-card>
  </b-container>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import AnalyticsMixin from '@/mixins/Analytics.js'

export default {
  name: 'Analytics',
  props: ['profile', 'site'],
  components: {DateRangePicker},
  mixins: [AnalyticsMixin]
}
</script>

<style scoped>

</style>
